import type { SendbirdGroupChannel } from '@sendbird/uikit-utils';
import { isWelcomeMessage } from './welcomeMessage';

export const getDisplayedUnreadCount = (channel: SendbirdGroupChannel): number =>
    isWelcomeMessage(channel.lastMessage) ? 0 : channel.unreadMessageCount;

const isChannelUnread = (channel: SendbirdGroupChannel): boolean => getDisplayedUnreadCount(channel) > 0;

export const countUnreadChannels = (channels: SendbirdGroupChannel[]): number => channels.filter(isChannelUnread).length;
